import Vue from "vue";
import VueWaypoint from "vue-waypoint";
import router from "@/router";
import App from "./App.vue";
import "./assets/styles/index.css";
import "./registerServiceWorker";

Vue.config.productionTip = false;

Vue.use(VueWaypoint);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
